/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProviderEcfmgCertificateList } from '../models/PaginatedProviderEcfmgCertificateList';
import type { PatchedProviderEcfmgCertificateWrite } from '../models/PatchedProviderEcfmgCertificateWrite';
import type { ProviderEcfmgCertificate } from '../models/ProviderEcfmgCertificate';
import type { ProviderEcfmgCertificateWrite } from '../models/ProviderEcfmgCertificateWrite';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProviderEcfmgCertificatesService {

    /**
     * @returns PaginatedProviderEcfmgCertificateList
     * @throws ApiError
     */
    public static providerEcfmgCertificatesList({
        limit,
        offset,
        provider,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        provider?: string,
    }): CancelablePromise<PaginatedProviderEcfmgCertificateList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-ecfmg-certificates/',
            query: {
                'limit': limit,
                'offset': offset,
                'provider': provider,
            },
        });
    }

    /**
     * @returns ProviderEcfmgCertificate
     * @throws ApiError
     */
    public static providerEcfmgCertificatesCreate({
        requestBody,
    }: {
        requestBody: ProviderEcfmgCertificateWrite,
    }): CancelablePromise<ProviderEcfmgCertificate> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/provider-ecfmg-certificates/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderEcfmgCertificate
     * @throws ApiError
     */
    public static providerEcfmgCertificatesRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this ecfmg certificate.
         */
        id: string,
    }): CancelablePromise<ProviderEcfmgCertificate> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-ecfmg-certificates/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProviderEcfmgCertificate
     * @throws ApiError
     */
    public static providerEcfmgCertificatesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this ecfmg certificate.
         */
        id: string,
        requestBody?: PatchedProviderEcfmgCertificateWrite,
    }): CancelablePromise<ProviderEcfmgCertificate> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/provider-ecfmg-certificates/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static providerEcfmgCertificatesDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this ecfmg certificate.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/provider-ecfmg-certificates/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
